import _slicedToArray from "C:/Users/mmira/Desktop/gatsby_sites/gatsby-komsc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createContext, createElement, useCallback, useRef } from 'react'; // -------------------------------------------------------
// context
// -------------------------------------------------------

var warningObject = {
  get state() {
    throw new Error('Please use <Provider>');
  },

  get dispatch() {
    throw new Error('Please use <Provider>');
  },

  get subscribe() {
    throw new Error('Please use <Provider>');
  }

};

var calculateChangedBits = function calculateChangedBits(a, b) {
  return a.update !== b.update || a.subscribe !== b.subscribe ? 1 : 0;
};

export var createCustomContext = function createCustomContext() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : warningObject;
  var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : calculateChangedBits;
  return createContext(w, c);
}; // -------------------------------------------------------
// provider
// -------------------------------------------------------

export var createProvider = function createProvider(context, useValue) {
  return function (props) {
    var _useValue = useValue(props),
        _useValue2 = _slicedToArray(_useValue, 2),
        state = _useValue2[0],
        update = _useValue2[1];

    var listeners = useRef([]); // we call listeners in render intentionally.
    // listeners are not technically pure, but
    // otherwise we can't get benefits from concurrent mode.
    // we make sure to work with double or more invocation of listeners.

    listeners.current.forEach(function (listener) {
      return listener(state);
    });
    var subscribe = useCallback(function (listener) {
      listeners.current.push(listener);

      var unsubscribe = function unsubscribe() {
        var index = listeners.current.indexOf(listener);
        listeners.current.splice(index, 1);
      };

      return unsubscribe;
    }, []);
    return createElement(context.Provider, {
      value: {
        state: state,
        update: update,
        subscribe: subscribe
      }
    }, props.children);
  };
};